import type { DoraFinancialEntity } from './doraFinancialEntity.ts';
import type { DoraBusinessService } from './doraBusinessService.ts';
import type { DoraICTService } from './doraICTService.ts';
import type { DoraRisk } from './doraRisk.ts';
import type { DoraFinding } from './doraFinding.ts';

export interface DoraIncident {
  id?: number;
  title: string;
  description?: string | null;
  occurred_at: string;
  severity?: string | null;
  financial_entity_id: number;
  business_service_id?: number | null;
  ict_service_id?: number | null;
  risk_id?: number | null;
  financial_entity?: DoraFinancialEntity;
  business_service?: DoraBusinessService | null;
  ict_service?: DoraICTService | null;
  risk?: DoraRisk | null;
  findings?: DoraFinding[];
}

export type DoraIncidentUpdate = Partial<Omit<DoraIncident,
  'id' |
  'financial_entity' |
  'business_service' |
  'ict_service' |
  'risk' |
  'findings'
>>;

export const doraIncidentToUpdate = ({
  id,
  financial_entity,
  business_service,
  ict_service,
  risk,
  findings,
  ...rest
}: DoraIncident): DoraIncidentUpdate => ({
  ...rest,
});
